module.exports = __webpack_public_path__ + "static/media/logo2.112a1c62.svg";